(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["benzwood-product-title"] && !Shopify.designMode) return;
  try {
    (() => {
  const isColour = text => /^(farbe|color|colour)(\s|:|$)/i.test(text.trim());
  function selectedColour(container) {
    for (const fieldset of container.querySelectorAll('fieldset')) {
      if (!isColour(fieldset.querySelector('legend')?.textContent || '')) continue;
      const checked = fieldset.querySelector('input[type="radio"]:checked');
      if (checked) return checked.value.trim();
    }
    for (const select of container.querySelectorAll('select')) {
      if ([...select.labels || []].some(label => isColour(label.textContent))) return select.value.trim();
    }
    return null;
  }
  function updateProductTitles() {
    for (const title of document.querySelectorAll('.product__title[data-base-title]')) {
      const container = title.closest('.product__info-container');
      const label = title.querySelector('.js-title-color');
      if (!container || !label) continue;
      const colour = selectedColour(container);
      if (colour === null) continue;
      const next = colour ? ` – ${colour}` : '';
      if (label.textContent !== next) label.textContent = next;
    }
  }
  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; updateProductTitles(); });
  }
  document.addEventListener('change', event => {
    if (event.target instanceof Element && event.target.closest('.product__info-container')) schedule();
  });
  for (const eventName of ['variant:change', 'variant:changed', 'shopify:section:load']) document.addEventListener(eventName, schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
